// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AlipaySquareFilledSvg from "@ant-design/icons-svg/es/asn/AlipaySquareFilled";
import AntdIcon from '../components/AntdIcon';

var AlipaySquareFilled = function AlipaySquareFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: AlipaySquareFilledSvg
  }));
};

AlipaySquareFilled.displayName = 'AlipaySquareFilled';
export default React.forwardRef(AlipaySquareFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/AlipaySquareFilled.js
// module id = 549
// module chunks = 0